/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';

import type { FilterResponse } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 알람 그룹 필터
 */
export const getV9AlertsFilter = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<FilterResponse>(
    { url: `/api/v9/alerts/filter`, method: 'GET', signal },
    options,
  );
};

export const getGetV9AlertsFilterQueryKey = () => {
  return ['api', 'v9', 'alerts', 'filter'] as const;
};

export const getGetV9AlertsFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsFilter>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsFilter>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsFilterQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertsFilter>>> = ({ signal }) =>
    getV9AlertsFilter(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsFilter>>,
    TError,
    TData
  >;
};

export type GetV9AlertsFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsFilter>>
>;
export type GetV9AlertsFilterQueryError = ErrorType<unknown>;

/**
 * @summary 알람 그룹 필터
 */

export function useGetV9AlertsFilter<
  TData = Awaited<ReturnType<typeof getV9AlertsFilter>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsFilter>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsFilterQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
